import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { Seo } from "@/components/site/Seo";
import TermDates from "@/components/site/TermDates";
import FinalCTA from "@/components/site/FinalCTA";

export default function TermDatesPage() {
  return (
    <div className="min-h-screen bg-white font-body" data-testid="term-dates-page">
      <Seo
        title="Term Dates | Happy Tiddlers Swimming"
        description="Happy Tiddlers swim school term dates — see when our terms run across the year in our warm 31–33°C pool in Barton-le-Clay."
        path="/term-dates"
      />
      <Navbar />
      <main className="pt-20">
        <TermDates />
      </main>
      <FinalCTA />
      <Footer />
    </div>
  );
}
